/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type ListEvaluationsPathParams = NonNullable<operations['listEvaluations']['parameters']['path']>;

export type ListEvaluationsQueryParams = NonNullable<operations['listEvaluations']['parameters']['query']>;

export interface Input extends ListEvaluationsPathParams {
  apiVersion?: string;
  query?: ListEvaluationsQueryParams;
}

export async function listEvaluations(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/internal/projects/{projKey}/evaluations', {
    params: { path, query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
